import { render, staticRenderFns } from "./LanguageBar.vue?vue&type=template&id=0ebf255a"
import script from "./LanguageBar.vue?vue&type=script&lang=js"
export * from "./LanguageBar.vue?vue&type=script&lang=js"
import style0 from "./LanguageBar.vue?vue&type=style&index=0&id=0ebf255a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports